function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.elements_to_shift = [];
      this.waitForShiftElement('#ShopifyChat');
      this.waitForShiftElement('.es-badge-container');

      this.alwaysShow = false;

    }

    waitForShiftElement(selector) {
      waitForElm(selector).then(() => {
        this.initShiftElement(selector);
      });
    }

    initShiftElement(selector) {
      const element = document.querySelector(`${selector}`);

      if (element && !element.classList.contains('will-shift')) {
        element.classList.add('will-shift');
        this.elements_to_shift.push(element);
        this.setShiftAmount();

        if ( !this.classList.contains('sticky-atc-panel--out') ) {
          this.elements_to_shift.forEach((element) => {
            element.classList.add('shifted');
          })
        }
      }
    }

    setShiftAmount() {
      if (this.elements_to_shift) {
        this.elements_to_shift.forEach((element) => {
          element.style.setProperty('--shift-amount', `${this.offsetHeight + this.style.marginBottom}px`);
        })
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        this.setShiftAmount();
        console.log("Recalculated shift amount");
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
            if (this.elements_to_shift) { 
              this.elements_to_shift.forEach((element) => {
                element.classList.toggle('shifted', entry.boundingClientRect.bottom < 0);
              })
            }
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            if (this.elements_to_shift) { 
              this.elements_to_shift.forEach((element) => {
                element.classList.toggle('shifted', !entry.isIntersecting);
              })
            }
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}